module.exports = __webpack_public_path__ + "static/media/LAUNCH.b94adb60.png";